var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410.67,
    height: 410.67,
    viewBox: "0 0 410.67 410.67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-208.35,-211.92)",
    d: "M 0,308 H 697.25 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m290.5 140.83v228.96h79.268v-228.96zm9.5391 14.492h61.734v15.066h-43.066v23.6h39.066v14.533h-39.066v25.066h43.066v15.066h-61.734zm42.33 106.13h18.666v93.334h-18.666z",
    fill: "#e6e6e6",
    strokeWidth: 0,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333,0,0,-1.3333,277.8,128.11)",
    d: "m0 0h59.449v66.08h-237.8v-237.8h178.35z",
    clipPath: "url(#clipPath56)",
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogoGrey);
export default __webpack_public_path__ + "static/media/mini_logo_grey.90799747740ae0b10bc01e9b205775af.svg";
export { ForwardRef as ReactComponent };